import {Link} from "react-router-dom";
import ContactStillNeedHelpComponent from "../../components/contact/ContactStillNeedHelpComponent.tsx";
import ContactPageLayout from "./ContactPageLayout.tsx";

export default function ContactInvoicePage() {
    return (
        <ContactPageLayout
            meta_title={"Regning og betalingskort på Mit Hiper"}
            meta_description={"Læs om hvordan du kan betale, forstå din første regning samt hvad din kreditnota er, hvis du har sådan en."}
            title={"Regning og betalingskort"}
            className={"page-contact-invoice"}
            content={
                <>
                    <section className="contact-content">
                        <p>
                            Find svar i disse artikler, hvis du har spørgsmål om din regning eller betalingskort:
                        </p>
                        <Link
                            to={'/hjaelp/regning-og-betaling/betalingsmuligheder'}
                            className={'button button--montserrat teal'}
                        >Hvordan kan jeg betale?</Link>
                        <Link
                            to={'/hjaelp/regning-og-betaling/forstaa-din-regning'}
                            className={'button button--montserrat teal'}
                        >Forstå din regning</Link>
                    </section>

                    <ContactStillNeedHelpComponent chat={true} form={true}/>
                </>
            }
        />
    )
}
